import tokens from './tokens.json'

export const BRAND_INK = tokens.ink
export const BRAND_SIGNAL = tokens.signal
export const SUN_PATH_D = tokens.sunPath
